// src/season-cluster/infrastructure/ui-services/seasonClusterUiService.ts

export const $SEASON_CLUSTER_ROUTE_QUERY_NAME = "season";
